import {
  Box,
  CircularProgress,
  IconButton,
  IconButtonProps,
} from '@mui/material';
import React from 'react';

export const ConnectBtnIcon = ({
  iconSlot,
  isDisabled,
  isLoading,
  ...rest
}: IconButtonProps & {
  iconSlot: React.ReactNode;
  isDisabled?: boolean;
  isLoading?: boolean;
}) => {
  return (
    <IconButton
      sx={{
        flex: 1,
        border: theme => `1px solid ${theme.palette.grey[200]}`,
        py: 2,
        borderRadius: 1,
        transition: theme => theme.transitions.create(['border', 'box-shadow']),
        '&:hover': {
          backgroundColor: 'transparent',
          borderColor: theme => theme.palette.customMain[800],
          boxShadow: theme => `0 0 0 3px ${theme.palette.customMain[400]}`,
        },
      }}
      {...rest}
    >
      <Box
        component="i"
        sx={{
          display: 'flex',
          fontSize: theme => theme.typography.pxToRem(36),
          opacity: isDisabled ? 0.7 : 1,
        }}
      >
        {isLoading ? <CircularProgress size={24} /> : iconSlot}
      </Box>
    </IconButton>
  );
};
